import { I18n } from '@aws-amplify/core';
import { message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { QUERY_KEYS } from '@/utils/query-keys';
import { BeraV2Service } from '@/infra/services/bera-v2';

import type { BeraSegmentAssignment } from '@/types/Bera';
import type { Response } from '@/types';

export interface PatchBeraJobSummaryParams {
	id: string;
	organization_id: string;
	company_id: string;
	assignments: BeraSegmentAssignment[];
}

const WIZARD_QUERY_KEYS = [QUERY_KEYS.GET_BERA_JOB_SUMMARY, QUERY_KEYS.GET_BERA_FILES, QUERY_KEYS.GET_BERA_REPORTS_V2];

const PATCH_ERROR_MESSAGE = 'Failed to send the videos for processing';

const Service = BeraV2Service.getInstance();

export function usePatchBeraJobSummary() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: PatchBeraJobSummaryParams) => Service.patchJobSummary(params),
		onSuccess: async () => {
			const invalidations = WIZARD_QUERY_KEYS.map((key) => queryClient.invalidateQueries([key]));

			await Promise.all(invalidations);
		},
		onError: (err: AxiosError<Response>) => {
			message.error(I18n.get(err.response?.data?.message ?? PATCH_ERROR_MESSAGE));
		}
	});
}
